<template>
  <Can action="store" subject="user">
    <div data-component-group="user-dialog" data-component="add-new">
      <dialog-add
        icon="account_circle"
        :title="$t('add_new_user')"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-user-add-new
            :is-loading="isAddingUser"
            class="elevation-1"
            :on-cancel="onCancel"
            :on-submit="createUser"
            :is-on="true"
          />
        </template>
      </dialog-add>
    </div>
  </Can>
</template>

<script>
  export default {
    data() {
      return {
        isAddingUser: false,
      };
    },
    created() {
      this.$store.dispatch('users/clearActiveItem');
    },
    computed: {
      parentRoute() {
        return this.$route.matched[0]?.name || 'users';
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: this.parentRoute });
      },
      createUser(user) {
        this.isAddingUser = true;

        return this.$store
          .dispatch('users/create', user)
          .then((res) => {
            if (res.data.status === 'success') {
              this.$router.push({ name: this.parentRoute, query: { status: 'success' } });
            }
            return res;
          })
          .finally(() => {
            this.isAddingUser = false;
          });
      },
    },
  };
</script>
